import React from 'react';
import Box from '@mui/material/Box';
import { Card } from '@mui/material';

const GetHelpComponent = () => {
  return (
    <Card>
      <Box p={4}>
        <Box>
          General Edgenuity/Program Questions? Please email <a href="mailto:jesse.fox@deltaacademylv.com">jesse.fox@deltaacademylv.com</a>
        </Box>

      {/*<Box p={4}>
        Summer School Questions? Please email <a href="mailto:austin.congleton@deltaacademylv.com">
                                          austin.congleton@deltaacademylv.com
                                        </a>
        
        <Box pt={3}>
          Questions about Classes?  Email your counselor:
        </Box>  
        <Box pl={5}>
          <ul>
            <li>
              Middle School: <a href="mailto:shiela.burns@deltaacademylv.com">
                            shiela.burns@deltaacademylv.com
                          </a>
            </li>
            <li>
              High School (Last Name A-L): <a href="mailto:kima.mkhitarian@deltaacademylv.com">
                            kima.mkhitarian@deltaacademylv.com
                          </a>
            </li>
            <li>
              High School (Last Name M-Z): <a href="mailto:jennifer.cann@deltaacademylv.com">
                              jennifer.cann@deltaacademylv.com
                            </a>
            </li>
          </ul>
        </Box>

        <Box pt={3}>
          Want to Zoom with a teacher?
        </Box>  
        <Box pl={5}>
          <ul>
            <li>
              Summer School Zoom - <a href="https://us06web.zoom.us/j/5904621714">https://us06web.zoom.us/j/5904621714</a>
            </li>  
          </ul>
        </Box>
      </Box>*/}  

        <Box pt={3}>
          Need to talk to someone?  Set up an appointment with one of our school social workers:
        </Box>
        <Box pl={5}>
          <ul>
            <li>
              Ms. Akazawa: <a href="mailto:kianna.akazawa@deltaacademylv.com">
                            kianna.akazawa@deltaacademylv.com
                          </a>
            </li>
            <li>
              Ms. Dominguez: <a href="mailto:elizah.dominguez@deltaacademylv.com">
                            elizah.dominguez@deltaacademylv.com
                          </a>
            </li>
            <li>
              Mr. Lujan:  <a href="ray.lujan@deltaacademylv.com">
                              ray.lujan@deltaacademylv.com
                            </a>
            </li>
          </ul>
        </Box>
        <Box pt={3}>
          Want to Zoom with a teacher? Here are the links:
        </Box>
        <Box pl={5}>
          <ul>
            <li>
                <strong>Attendance & Test Proctoring: </strong>
                  Open Sunday, Monday, Tuesday, Thursday, and Friday - 8:00AM - 3:00PM Wednesday - 8:00AM - 2:30PM<br />
                  <a href="https://zoom.us/j/6287492310">https://zoom.us/j/6287492310</a>
            </li>  
            <li>
                <strong>Test Proctoring: </strong>
                  Open Monday, Tuesday, Thursday, and Friday - 8:00AM - 3:00PM Wednesday - 8:00AM - 3:00PM (Closed for Lunch 11:00AM - 11:45AM each day.)<br />
                  <a href="https://zoom.us/j/8331295548">https://zoom.us/j/8331295548</a>
            </li>  
            <li>
                <strong>Spanish Teacher Test Proctoring: </strong>
                  Open Tuesdays - 8:00AM-11:30AM and Thursdays - 11:30AM - 3:00PM<br />
                  <a href="https://zoom.us/j/3579088270">https://zoom.us/j/3579088270</a>
            </li>  
            <li>
                <strong>After Hours Attendance & Test Proctoring Zoom: </strong>
                  Sunday, Monday, Tuesday, Wednesday, Thursday ~ 4:00PM - 10:00PM<br />
                  <a href="https://zoom.us/j/3579088270">https://zoom.us/j/3579088270</a>
            </li>  
          </ul>  
        </Box>  



        <Box pl={2} pt={2}>
          Subject Specific Zooms: 
        </Box>
        <Box pl={5}>
          <ul>
            <li>
              <strong>English - Paul McLerran</strong> (Monday - Friday from 8:00AM-3:00PM) <br /> <a href="https://us06web.zoom.us/j/4456893755">https://us06web.zoom.us/j/4456893755</a>
            </li>
            <li>
              <strong>Math - Sierra South</strong> (Monday - Friday from 8:00AM-3:00PM) <br /> <a href="https://us06web.zoom.us/j/9691572663">https://us06web.zoom.us/j/9691572663</a>
            </li>
            <li>
              <strong>Science - Alisa South</strong> (Monday - Friday from 8:00AM-3:00PM) <br /> <a href="https://us06web.zoom.us/j/8965780848">https://us06web.zoom.us/j/8965780848</a>
            </li>
            <li>
              <strong>Social Studies, Electives, Computer Science, and additional subject areas - Benjamin Pennington</strong> (Tuesday - Saturday from 8:00AM-3:00PM) <br /> <a href="https://zoom.us/j/5904621714">https://zoom.us/j/5904621714</a>
            </li>
          </ul>
        </Box>
      </Box>

      <Box pl={5} pb={2}>
        <strong>Tutoring & Technical Assistance: </strong>Open from 8:00AM-3:00PM Monday, Tuesday, Wednesday, Thursday, and Friday (Closed for Lunch 11:00AM - 11:45AM each day.)<br />
        <a href="https://zoom.us/j/2725901146">https://zoom.us/j/2725901146</a>
      </Box>

    </Card>
  );
};

export default GetHelpComponent;
